import { useState } from 'react';
import { Button, Grid } from "@material-ui/core";
import { consoleButtons } from "constants/admin/masters/labs";
import ConsoleGrid from '../templates/ConsoleGrid';
import HtmlConsole from '../templates/HtmlConsole';
import UrlConsole from '../templates/UrlConsole';
import VAppConsole from '../templates/VAppConsole';
import uuid from 'react-uuid';
import { useStyles } from '../style';

const renderContent = (labId, vAppId, activeBtn, setActiveBtn, setActivateButton, setVAppId,checkActiveConsoleScreen) => {
    switch (activeBtn) {
        case 'Add Template':
            return <VAppConsole labId={labId} vAppId={vAppId} setActiveBtn={setActiveBtn} setActivateButton={setActivateButton} checkActiveConsoleScreen={checkActiveConsoleScreen} />
        case 'Add Url':
            return <UrlConsole setActiveBtn={setActiveBtn} />
        case 'Add Html':
            return <HtmlConsole setActiveBtn={setActiveBtn} />
        default:
            return <ConsoleGrid labId={labId} vAppId={vAppId} handleEdit={handleEdit} setActiveBtn={setActiveBtn} setActivateButton={setActivateButton} setVAppId={setVAppId} checkActiveConsoleScreen={checkActiveConsoleScreen} />
    }
}

const handleEdit = (rowData, setActiveBtn, setVAppId,checkActiveConsoleScreen) => {
    setVAppId(rowData?.id)
    setActiveBtn('Add Template');
    checkActiveConsoleScreen('Add Template')
}


export default function ConsoleTab(props) {
    const { labId, checkActiveConsoleScreen } = props;
    const classes = useStyles();
    const [activeBtn, setActiveBtn] = useState('');
    const [vAppId, setVAppId] = useState('');
    const [activateButton, setActivateButton] = useState(true);
    const handleChange = (btnName) => {
        setActiveBtn(btnName);
        setVAppId('');
        checkActiveConsoleScreen(btnName)
    }

    return (
        <>
            {!activeBtn && <Grid item xs={12}>
                {consoleButtons.map(button => {
                    return (
                        activateButton && <Button
                            key={uuid()}
                            className={classes.consoleButtons}
                            color="primary"
                            variant="contained"
                            onClick={() => handleChange(button)}
                        >
                            {button}
                        </Button>
                    )
                })}
            </Grid>
            }
            <Grid item xs={12}>
                {renderContent(labId, vAppId, activeBtn, setActiveBtn, setActivateButton, setVAppId,checkActiveConsoleScreen)}
            </Grid>
        </>
    )
}